module.exports = __webpack_public_path__ + "img/fondoArtes.052b38f2.jpg";